import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/layout/Header';
import ExplorePage from './pages/ExplorePage';
import AircraftDetailPage from './pages/AircraftDetailPage';

function App() {
  return (
    <BrowserRouter>
      <div className="app">
        {/* Header */}
        <Header />

        {/* Routes */}
        <Routes>
          <Route path="/" element={<ExplorePage />} />
          <Route path="/aircraft/:id" element={<AircraftDetailPage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
